<template>
	<div
		v-if="filledBars > 0"
		class="loudness-indicator"
		:title="`Intensity: ${value}/10`"
	>
		<span
			v-for="i in 5"
			:key="i"
			class="loudness-indicator__bar"
			:class="{ '-filled': i <= filledBars }"
			:style="{ height: `${4 + (i * 2)}px` }"
		/>
	</div>
</template>

<script>
export default {
	name:  'LoudnessIndicator',
	props: {
		value: {
			type:    Number,
			default: null,
		},
	},
	computed: {
		filledBars() {
			if (this.value == null || this.value <= 0) return 0;
			return Math.round(Math.min(this.value, 10) / 2);
		},
	},
};
</script>

<style lang="scss" scoped>
.loudness-indicator {
	display: inline-flex;
	align-items: flex-end;
	gap: 2px;
	flex-shrink: 0;
}

.loudness-indicator__bar {
	width: 2px;
	border-radius: 1px;
	background-color: var(--color-grey-700);

	&.-filled {
		background-color: var(--color-soft-white);
	}
}
</style>
